"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSearchResultContext = exports.SearchResultContext = void 0;
const React = require("react");
exports.SearchResultContext = React.createContext(null);
const useSearchResultContext = () => {
    const context = React.useContext(exports.SearchResultContext);
    if (!context) {
        throw new Error('useSearchResultContext must be used within a SearchResultContext.Provider');
    }
    return context;
};
exports.useSearchResultContext = useSearchResultContext;
